"use client";

import {
  useQuery,
  useQueryClient,
  type QueryClient,
} from "@tanstack/react-query";

import type { PublishedLinkRow } from "@/lib/billing/published-links";
import { queryKeys } from "@/lib/react-query/query-keys";

type ApiSuccess = { success: true; data: { items: PublishedLinkRow[] } };

async function fetchPublishedLinks(): Promise<PublishedLinkRow[]> {
  const res = await fetch("/api/published", { credentials: "include" });
  if (!res.ok) throw new Error("Failed to load published links");
  const payload = (await res.json()) as ApiSuccess;
  return payload.data.items ?? [];
}

export function usePublishedLinksQuery(initialItems?: PublishedLinkRow[]) {
  return useQuery({
    queryKey: queryKeys.publishedLinks(),
    queryFn: fetchPublishedLinks,
    ...(initialItems !== undefined
      ? { initialData: initialItems, initialDataUpdatedAt: 0 }
      : {}),
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}

export function invalidatePublishedLinksQuery(qc: QueryClient) {
  void qc.invalidateQueries({ queryKey: queryKeys.publishedLinks() });
}
